export const phoneRegExp = /^(?:\+1|1)?[2-9]\d{9}$/;

export const addPlusOne = (phoneNumber: string) => {
  if (!phoneNumber) {
    return undefined;
  }
  if (!phoneRegExp.test(phoneNumber)) {
    return phoneNumber;
  }
  if (phoneNumber.startsWith('+1')) {
    return phoneNumber;
  }
  if (phoneNumber.startsWith('1')) {
    return `+${phoneNumber}`;
  }
  return `+1${phoneNumber}`;
};
